import {createContext, useReducer, useEffect} from 'react'

// Creating the context 
export const AuthContext = createContext()

// This is our auth reducer to handle login and logout requests
export const authReducer = (state,action) => {

    switch(action.type){
        case"LOGIN":
        return {user: action.payload}
        case "LOGOUT": 
        return {user: null}
        default:
            return state
    }
}


// This provides access to our AuthContext
export const AuthContextProvider = ({children}) => {

    //gives children access to our reducer we created above.
    const [state,dispatch] = useReducer(authReducer,{user:null})

    // This function will fire and log us in if token is still in localStorage
    useEffect(()=> {
        const user = JSON.parse(localStorage.getItem('user'))

        if(user){
            dispatch({type: "LOGIN", payload: user})
        }
    }, [])

    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            {children}
        </AuthContext.Provider>
    )

}